import Image from 'next/image'
import { useEffect, useState } from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'
import Script from 'next/script'
import {
  Footer,
  Header,
  TryEdworking,
  EdworkingBanner,
  Testimonials,
  EdworkingPromotion,
  FeaturesIntro,
  ReviewsTrust,
  TopBanner,
} from '../../js/components'
import { SERVER_URL, validateEmail, newLive } from '../../js'
import Link from 'next/link'
import { OrganizationSchema, WebPageSchema, BreadcrumbListSchema } from '../../js/schemas'
import path from 'path'
import fs from 'fs/promises' // or 'fs' if using callbacks

export async function getStaticProps({ locale, locales }) {
  let content
  try {
    const filePath = path.join(process.cwd(), 'public', 'content', locale, 'features.json')

    const jsonData = await fs.readFile(filePath, 'utf8')
    content = JSON.parse(jsonData)
  } catch (error) {
    console.error('error', error)
  }
  return {
    props: { content, locale, locales },
  }
}

export default function Features({ content, locale, locales }) {
  const [promotion, setPromotion] = useState(false)

  const onMouseOut = () => {
    const goon = localStorage.getItem('promotion')
    if (!goon) setPromotion(true)
    document.body.removeEventListener('mouseleave', onMouseOut)
  }

  useEffect(() => {
    setTimeout(function () {
      document.body.addEventListener('mouseleave', onMouseOut)
    }, 3000)
  }, [])
  return (
    <>
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=UA-166939348-2"
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            
            gtag('config', 'UA-166939348-2');
        `}
      </Script>
      <Script id="google-tag-manager" strategy="afterInteractive">
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-NRW96HD');
        `}
      </Script>
      <Script id="hotjar" strategy="afterInteractive">
        {`
          (function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:2080824,hjsv:6};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `}
      </Script>
      <OrganizationSchema />
      <WebPageSchema name={content.head.title} description={content.head.description} />
      <BreadcrumbListSchema
        items={[
          {
            name: 'Home',
            url: `https://edworking.com/${locale !== 'en' ? `${locale}/` : ''}`,
          },
          {
            name: 'Features',
            url: `https://edworking.com/${locale !== 'en' ? `${locale}/` : ''}features`,
          },
        ]}
      />
      <Head>
        <title>{content.head.title}</title>
        <meta itemProp="name" content={content.head.title} />
        <meta itemProp="description" content={content.head.description} />
        <meta name="description" content={content.head.description} />
        <link rel="shortcut icon" href="/images/favicon.ico" />
        {locales.map((locale1, index) => (
          <link
            key={index}
            rel="alternate"
            hrefLang={locale1}
            href={`https://edworking.com${locale1 !== 'en' ? `/${locale1}` : ''}/features`}
          />
        ))}
        <link rel="alternate" href={`https://edworking.com/features`} hrefLang="x-default" />
        <link
          rel="canonical"
          href={`https://edworking.com/${locale !== 'en' ? `${locale}/` : ''}features`}
          key="canonical"
        />
      </Head>
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NRW96HD" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
        }}
      />
      <EdworkingPromotion promotion={promotion} content={content.promotion} />
      {/*<TopBanner content={content.topbanner} />*/}
      <Header clean content={content.header} topbanner={true} />
      <IntroFeature content={content.intro} />
      <NavigationFeature
        content={content.navigation}
        scrollTo={(to) =>
          document.getElementById(to).scrollIntoView({ block: 'start', behavior: 'smooth' })
        }
      />
      {/*<FeaturesIntro content={content.introfeatures} />*/}
      {/*<EdworkingBanner content={content.edworkingbanner} />*/}
      <TaskFeature content={content.features} />
      <AiFeature content={content.features} />
      <ChatFeature content={content.features} />
      <VideoFeature content={content.features} />
      <DocFeature content={content.features} />
      <CollaborationFeature content={content.features} />
      <div className="barcolors1"></div>
      <Testimonials content={content.reviews} />
      <TryEdworking content={content.endbanner} />
      <Footer content={content.footer} />
      <div id="livenoti" className="livenoti"></div>
    </>
  )
}
const AiFeature = ({ content }) => {
  const { ai, button, replaces } = content
  return (
    <section className="feature feat" id="ai">
      <h2 className="supratitle">{ai.name.toUpperCase()}</h2>
      <h2 className="title">{ai.slogan}</h2>
      <h2 className="description">{ai.description}</h2>
      <div className="benefits-feature blue">
        <div className="points">
          <div className="description replaces">
            {replaces}
            <Image width={20} height={20} src="/images/main/Openai.png" alt="Logo Drive" />
            <Image width={20} height={20} src="/images/main/Gemini.png" alt="Logo Dropbox" />
          </div>
          {ai.benefits.map((benefit, index) => (
            <li key={index} className="description">
              <span>{benefit.title}</span>
              <p>{benefit.description}</p>
            </li>
          ))}
          <Link className="blueButton" href="/features/files">
            {button}
          </Link>
        </div>
        <div className="image">
          <video
            preload="none"
            muted
            loop
            autoPlay
            className="video"
            src="https://storage.googleapis.com/dratini/features/AIMain.mp4"
            alt="Chat"
          />
        </div>
      </div>
      <div className="strengths">
        {ai.strengths.map((strength, index) => (
          <div key={index} className="strength">
            <Image width={25} height={25} src={strength.img} alt="" />
            <span>{strength.title}</span>
            <p>{strength.description}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
const CollaborationFeature = ({ content }) => {
  const { collaboration, button, replaces } = content
  return (
    <section className="feature feat" id="collaboration">
      <h2 className="supratitle">{collaboration.name.toUpperCase()}</h2>
      <h2 className="title">{collaboration.slogan}</h2>
      <h2 className="description">{collaboration.description}</h2>
      <div className="benefits-feature red">
        <div className="image">
          <video
            preload="none"
            muted
            loop
            autoPlay
            className="video"
            src="https://storage.googleapis.com/dratini/VideoRecording/Files1.mp4"
            alt="Chat"
          />
        </div>
        <div className="points">
          <div className="description replaces">
            {replaces}
            <Image width={20} height={20} src="/images/main/Drive.png" alt="Logo Drive" />
            <Image width={20} height={20} src="/images/main/Dropbox.png" alt="Logo Dropbox" />
            <Image width={20} height={20} src="/images/main/Loom.png" alt="Logo Asana" />
          </div>
          {collaboration.benefits.map((benefit, index) => (
            <li key={index} className="description">
              <span>{benefit.title}</span>
              <p>{benefit.description}</p>
            </li>
          ))}
          <Link className="blueButton" href="/features/collaboration">
            {button}
          </Link>
        </div>
      </div>
      <div className="strengths">
        {collaboration.strengths.map((strength, index) => (
          <div key={index} className="strength">
            <Image width={25} height={25} src={strength.img} alt="" />
            <span>{strength.title}</span>
            <p>{strength.description}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
const DocFeature = ({ content }) => {
  const { docs, button, replaces } = content
  return (
    <section className="feature feat" id="docs">
      <h2 className="supratitle">{docs.name.toUpperCase()}</h2>
      <h2 className="title">{docs.slogan}</h2>
      <h2 className="description">{docs.description}</h2>
      <div className="benefits-feature green">
        <div className="points">
          <div className="description replaces">
            {replaces}
            <Image width={20} height={20} src="/images/main/Notion.png" alt="Logo Asana" />
            <Image
              width={20}
              height={20}
              src="/images/main/Confluence.png"
              alt="Logo Airtable"
            />
          </div>
          {docs.benefits.map((benefit, index) => (
            <li key={index} className="description">
              <span>{benefit.title}</span>
              <p>{benefit.description}</p>
            </li>
          ))}
          <Link className="blueButton" href="/features/docs">
            {button}
          </Link>
        </div>
        <div className="image">
          <video
            preload="none"
            muted
            loop
            autoPlay
            className="video"
            src="https://storage.googleapis.com/dratini/features/DocsMain.mp4"
            alt="Chat"
          />
        </div>
      </div>
      <div className="strengths">
        {docs.strengths.map((strength, index) => (
          <div key={index} className="strength">
            <Image width={25} height={25} src={strength.img} alt="" />
            <span>{strength.title}</span>
            <p>{strength.description}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
const VideoFeature = ({ content }) => {
  const { videocalls, button, replaces } = content
  return (
    <section className="feature feat" id="video">
      <h2 className="supratitle">{videocalls.name.toUpperCase()}</h2>
      <h2 className="title">{videocalls.slogan}</h2>
      <h2 className="description">{videocalls.description}</h2>
      <div className="benefits-feature yellow">
        <div className="image">
          <video
            preload="none"
            muted
            loop
            autoPlay
            className="video"
            src="https://storage.googleapis.com/dratini/features/VideocallMain.mp4"
            alt="Task Management"
          />
        </div>
        <div className="points">
          <div className="description replaces">
            {replaces}
            <Image width={20} height={20} src="/images/main/Zoom.png" alt="Logo Asana" />
            <Image width={20} height={20} src="/images/main/Meets.png" alt="Logo Airtable" />
            <Image width={20} height={20} src="/images/main/Skype.png" alt="Logo Trello" />
          </div>
          {videocalls.benefits.map((benefit, index) => (
            <li key={index} className="description">
              <span>{benefit.title}</span>
              <p>{benefit.description}</p>
            </li>
          ))}
          <Link className="blueButton" href="/features/videocalls">
            {button}
          </Link>
        </div>
      </div>
      <div className="strengths">
        {videocalls.strengths.map((strength, index) => (
          <div key={index} className="strength">
            <Image width={25} height={25} src={strength.img} alt="" />
            <span>{strength.title}</span>
            <p>{strength.description}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
const ChatFeature = ({ content }) => {
  const { chat, button, replaces } = content
  return (
    <section className="feature feat" id="chat">
      <h2 className="supratitle">{chat.name.toUpperCase()}</h2>
      <h2 className="title">{chat.slogan}</h2>
      <h2 className="description">{chat.description}</h2>
      <div className="benefits-feature blue">
        <div className="points">
          <div className="description replaces">
            {replaces}
            <Image width={20} height={20} src="/images/main/Whatsapp.png" alt="Logo Asana" />
            <Image width={20} height={20} src="/images/main/Slack.png" alt="Logo Airtable" />
            <Image width={20} height={20} src="/images/main/Teams.png" alt="Logo Trello" />
          </div>
          {chat.benefits.map((benefit, index) => (
            <li key={index} className="description">
              <span>{benefit.title}</span>
              <p>{benefit.description}</p>
            </li>
          ))}
          <Link className="blueButton" href="/features/chat">
            {button}
          </Link>
        </div>
        <div className="image">
          <video
            preload="none"
            muted
            loop
            autoPlay
            className="video"
            src="https://storage.googleapis.com/dratini/VideoRecording/Chat2.mp4"
            alt="Chat"
          />
        </div>
      </div>
      <div className="strengths">
        {chat.strengths.map((strength, index) => (
          <div key={index} className="strength">
            <Image width={25} height={25} src={strength.img} alt="" />
            <span>{strength.title}</span>
            <p>{strength.description}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
const TaskFeature = ({ content }) => {
  const { task, button, replaces } = content
  return (
    <section className="feature feat" id="project-management">
      <h2 className="supratitle">{task.name.toUpperCase()}</h2>
      <h2 className="title">{task.slogan}</h2>
      <h2 className="description">{task.description}</h2>
      <div className="benefits-feature red">
        <div className="image">
          <video
            preload="none"
            muted
            loop
            autoPlay
            className="video"
            src="https://storage.googleapis.com/dratini/VideoRecording/Task2.mp4"
            alt="Task Management"
          />
        </div>
        <div className="points">
          <div className="description replaces">
            {replaces}
            <Image width={20} height={20} src="/images/compare/Asana.png" alt="Logo Asana" />
            <Image
              width={20}
              height={20}
              src="/images/compare/Airtable.png"
              alt="Logo Airtable"
            />
            <Image width={20} height={20} src="/images/compare/Trello.png" alt="Logo Trello" />
            <Image width={20} height={20} src="/images/compare/Monday.png" alt="Logo Monday" />
          </div>
          {task.benefits.map((benefit, index) => (
            <li key={index} className="description">
              <span>{benefit.title}</span>
              <p>{benefit.description}</p>
            </li>
          ))}
          <Link className="blueButton" href="/features/task">
            {button}
          </Link>
        </div>
      </div>
      <div className="strengths">
        {task.strengths.map((strength, index) => (
          <div key={index} className="strength">
            <Image width={25} height={25} src={strength.img} alt="" />
            <span>{strength.title}</span>
            <p>{strength.description}</p>
          </div>
        ))}
      </div>
    </section>
  )
}

const NavigationFeature = ({ scrollTo, content }) => {
  const router = useRouter()
  const [activeSection, setActiveSection] = useState('')
  const updateHash = (feature) => {
    router.push(`#${feature}`, undefined, { shallow: true })
  }
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id)
          }
        })
      },
      { threshold: 0.5 }
    )

    // Observe sections with IDs ending in 'nav'
    document.querySelectorAll('section[id]').forEach((section) => {
      observer.observe(section)
    })
    return () => {
      observer.disconnect()
    }
  }, [])
  return (
    <section className="subnavigation">
      <div className="barcolors1" style={{ height: 2 }}></div>
      <div className="categories" id="navigation">
        <div
          id="tasknav"
          className={`category${activeSection === 'project-management' ? ' active' : ''}`}
          onClick={() => updateHash('project-management')}
        >
          <Image width={20} height={20} src="/images/features/Tasks.svg" alt="category" />
          <span>{content.task}</span>
        </div>
        <div
          id="filenav"
          className={`category${activeSection === 'ai' ? ' active' : ''}`}
          onClick={() => updateHash('ai')}
        >
          <Image width={20} height={20} src="/images/Eder.svg" alt="category" />
          <span>{content.ai}</span>
        </div>
        <div
          id="chatnav"
          className={`category${activeSection === 'chat' ? ' active' : ''}`}
          onClick={() => updateHash('chat')}
        >
          <Image width={20} height={20} src="/images/features/Chat.svg" alt="category" />
          <span>{content.chat}</span>
        </div>
        <div
          id="videonav"
          className={`category${activeSection === 'video' ? ' active' : ''}`}
          onClick={() => updateHash('video')}
        >
          <Image width={20} height={20} src="/images/features/Calls.svg" alt="category" />
          <span>{content.video}</span>
        </div>
        <div
          id="docnav"
          className={`category${activeSection === 'docs' ? ' active' : ''}`}
          onClick={() => updateHash('docs')}
        >
          <Image width={20} height={20} src="/images/features/Workspace.svg" alt="category" />
          <span>{content.doc}</span>
        </div>
        <div
          id="storynav"
          className={`category${activeSection === 'collaboration' ? ' active' : ''}`}
          onClick={() => updateHash('collaboration')}
        >
          <Image width={20} height={20} src="/images/features/Stories.svg" alt="category" />
          <span>{content.collaboration}</span>
        </div>
      </div>
    </section>
  )
}
const IntroFeature = ({ content }) => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState({ email: false })

  const submit = () => {
    if (email === '') {
      setError({ email: true })
      newLive('/images/Logo.svg', '', content.validEmail)
    } else if (!validateEmail(email)) {
      setError({ email: true })
      newLive('/images/Logo.svg', email, content.invalidEmail)
    } else {
      fetch(SERVER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          operationName: 'NewUserPromotion',
          query:
            'mutation NewUserPromotion($email: String!, $promotion: Int) {newUserPromotion(email: $email, promotion: $promotion){ id }}',
          variables: { email: email, promotion: 4 },
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.errors) {
            newLive('/images/Logo.svg', email, content.registered)
          } else {
            window.location = `https://app.edworking.com/signup/user/u/${res.data.newUserPromotion.id}`
          }
          setEmail('')
        })
        .catch((e) => newLive('/images/Logo.svg', email, content.registered))
    }
  }

  return (
    <section
      className="import intro"
      style={{ margin: '200px auto', justifyContent: 'space-between' }}
    >
      <div className="column" style={{ width: '40%', zIndex: 2 }}>
        <h1 className="title">
          {content.title1} <span className="highlight">{content.title2}</span>
        </h1>
        <h2 className="description">{content.description}</h2>
        <input
          type="text"
          style={{
            border: error.email
              ? '1px solid rgb(255, 148, 171)'
              : '1px solid rgba(223, 228, 229, 0.658824)',
          }}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="textInput"
          placeholder={content.input}
        />
        <div style={{ display: 'flex', margin: '20px 0' }}>
          <div className="blueButton" style={{ width: 220 }} onClick={() => submit()}>
            {content.button}
          </div>
        </div>
        <ReviewsTrust />
      </div>
      <div className="column" style={{ width: '55%', overflow: 'hidden' }}>
        <video
          preload="none"
          muted
          loop
          autoPlay
          className="video"
          src="https://storage.googleapis.com/dratini/VideoRecording/UIAnimation.mp4"
          alt="Task Management"
        />
      </div>
    </section>
  )
}
